var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 5.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 0.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 0.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 5.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 0.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 5.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 0.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 5.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 0.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 5.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 0.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 5.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 0.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 5.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 10.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 10.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 10.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 10.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 10.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 10.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 10.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 15.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 15.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 15.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 15.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 15.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 15.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 15.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 20.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 20.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 20.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 20.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 20.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 20.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 20.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 25.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 25.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 25.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 25.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 25.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 25.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 25.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 30.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 30.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 30.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 30.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 30.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 30.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 30.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 35.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 35.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 35.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 35.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 35.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 35.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 35.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 0.5,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.b378093124d7e3cfb0673fbd2df46d19.svg";
export { ForwardRef as ReactComponent };